__turbopack_context__.v({
  "eyebrow": "TalesBlockHeader-module-scss-module__n-f0UG__eyebrow",
  "fade-in": "TalesBlockHeader-module-scss-module__n-f0UG__fade-in",
  "headline": "TalesBlockHeader-module-scss-module__n-f0UG__headline",
  "inner": "TalesBlockHeader-module-scss-module__n-f0UG__inner",
  "isInView": "TalesBlockHeader-module-scss-module__n-f0UG__isInView",
  "lockup": "TalesBlockHeader-module-scss-module__n-f0UG__lockup",
  "lockupEyebrow": "TalesBlockHeader-module-scss-module__n-f0UG__lockupEyebrow",
  "root": "TalesBlockHeader-module-scss-module__n-f0UG__root",
  "svgContainerAfter": "TalesBlockHeader-module-scss-module__n-f0UG__svgContainerAfter",
  "svgContainerBefore": "TalesBlockHeader-module-scss-module__n-f0UG__svgContainerBefore",
});
